import React from 'react';

export default function StackedListWrapper({ children, className = '' }) {
  return (
    <div className={`bg-gray-900 text-white rounded-lg shadow overflow-hidden ${className}`}>
      {children}
    </div>
  );
}
